module.exports = __webpack_public_path__ + "static/media/Checkbox_Deselected@3x.b68d422e.png";